import { API } from '../../providers/ApiInterceptorProvider';
import {
  BrokerCasesTasksResponse,
  BrokerCasesUploadDocPayload,
  BrokerCasesPatchIndividualPayload,
  CaseSearchParams,
  CaseSearchResponse,
  DocumentReview,
  DocumentReviewStatus,
  DocumentReviewType,
} from './types';

export const brokerCasesApi = {
  searchCases: async (params: CaseSearchParams): Promise<CaseSearchResponse> => {
    const response = await API.get<CaseSearchResponse>(`/monolith/broker/cases`, { params });
    return response.data;
  },

  getTasks: async (caseId: string): Promise<BrokerCasesTasksResponse> => {
    const response = await API.get<BrokerCasesTasksResponse>(`/monolith/broker/cases/${caseId}/tasks`);
    return response.data;
  },

  getDocumentReviews: async (
    caseId: string,
    individualId: string,
    status: DocumentReviewStatus,
    type: DocumentReviewType,
  ): Promise<DocumentReview[]> => {
    const response = await API.get<DocumentReview[]>(
      `/monolith/broker/cases/${caseId}/individuals/${individualId}/document-reviews`,
      {
        params: {
          status,
          type,
        },
      },
    );
    return response.data;
  },

  uploadDoc: async (caseId: string, files: File[], payload: BrokerCasesUploadDocPayload[], taskId: string) => {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));

    const meta = payload.map(p => ({
      ...p,
      description: p.description === '' ? undefined : p.description,
    }));
    formData.append('meta', JSON.stringify(meta));
    formData.append('taskId', taskId);

    await API.post(`/monolith/broker/cases/${caseId}/docs/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  patchIndividualShareCode: async (
    caseId: string,
    individualId: string,
    payload: BrokerCasesPatchIndividualPayload,
  ) => {
    await API.put(`/monolith/broker/cases/${caseId}/individuals/${individualId}/share-codes`, payload);
  },
};
